<div class="ap-bookshelf-card">
  <div class="d-flex">
    <div class="ap-bookshelf-card-header">
      <a #titleAnchor
         class="ap-bookshelf-card-header-title"
         data-automation-id="bookshelf-card-title"
         [id]="ariaTitleId"
         [tippy]="getTitle()"
         (click)="$event.preventDefault(); cardClick.emit()"
         href="">
        {{ getTitle() }}
      </a>
    </div>

    <div *ngIf="cardActions.length" ngbDropdown placement="left-top">
      <button #actionsMenuToggleButton
              [attr.aria-describedby]="ariaTitleId"
              [attr.aria-label]="'bookshelfCardMoreActionsButtonLabel' | translate"
              aria-haspopup="menu"
              class="p-0 app-button ap-bookshelf-card-more"
              data-automation-id="bookshelf-card-more-btn"
              (click)="toggleDropdown()"
              ngbDropdownToggle
              type="button">
        <fa-icon class="ap-bookshelf-card-more-icon" [icon]="ellipsisIcon"></fa-icon>
      </button>
      <div class="py-2" ngbDropdownMenu role="menu" data-automation-id="ap-bookshelf-card-more-dropdown">
        <button *ngFor="let cardAction of cardActions"
                [attr.aria-describedby]="ariaTitleId"
                (click)="onTriggerAction(cardAction)"
                aria-haspopup="dialog"
                class="d-block py-2 px-3 w-100 h-auto app-button bookshelf-card-action-btn"
                data-automation-id="ap-bookshelf-card-more-action-btn"
                ngbDropdownItem
                role="menuitem">
          <ng-template [ngTemplateOutlet]="cardAction.template"></ng-template>
        </button>
        <div *ngIf="isLoading">
          <div class="d-flex justify-content-center pt-5">
            <div class="spinner-container" role="status" aria-live="polite">
              <div class="spinner-border text-primary" data-automation-id="custom-showcase-spinner">
                <span class="sr-only" translate>Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ap-bookshelf-card-footer d-flex flex-row justify-content-between align-items-center px-3">
    <div class="d-flex align-items-center">
      <div *ngIf="cardShareActions.length && !isRapido" class="d-inline-block" ngbDropdown placement="right-top auto">
        <button #shareMenuToggleButton
                [attr.aria-describedby]="ariaTitleId"
                [attr.aria-label]="'bookshelfCardShare' | translate"
                aria-haspopup="menu"
                class="ap-bookshelf-card-footer-share p-1 border-0"
                data-automation-id="bookshelf-card-footer-share-btn"
                ngbDropdownToggle
                type="button">
          <fa-icon [icon]="sharedIcon"></fa-icon>
        </button>
        <div class="py-2" ngbDropdownMenu role="menu" data-automation-id="bookshelf-card-share-dropdown">
          <button *ngFor="let cardShareAction of cardShareActions"
                  [attr.aria-describedby]="ariaTitleId"
                  (click)="onTriggerShareAction(cardShareAction)"
                  class="d-block py-2 px-3 w-100 h-auto app-button bookshelf-card-action-btn"
                  data-automation-id="bookshelf-card-footer-share-action-btn"
                  ngbDropdownItem
                  role="menuitem">
            <ng-template [ngTemplateOutlet]="cardShareAction.template"></ng-template>
          </button>
        </div>
      </div>

      <ng-content select="app-ap-bookshelf-card-action-state"></ng-content>
    </div>

    <div *ngIf="cardStatus">
      <ng-template [ngTemplateOutlet]="cardStatus.template"></ng-template>
    </div>
  </div>
</div>
